import React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import TableStyle from "styles/application/TableStyle";

const AT = TableStyle();

const ARROW_ACTIVE = "#D2D2D9";
const ARROW_IDLE = "#F9F9FC";

const ModelTaskHeader = ({
	headerGroup,
	classes,
	cx,
	selection,
	showSelection,
}) => {
	const { t } = useTranslation();
	return (
		<TableRow>
			{showSelection && (
				<TableCell
					padding="checkbox"
					className={cx(classes.tableHeadRow, classes.selectionCell)}
				>
					<Checkbox
						size="small"
						checked={selection.headerState === "all"}
						indeterminate={selection.headerState === "some"}
						onChange={(event) => selection.toggleAllLoaded(event.target.checked)}
						inputProps={{ "aria-label": t("action.selectAllLoadedTasks") }}
					/>
				</TableCell>
			)}
			{headerGroup.headers.map((header) => {
				const sortDirection = header.column.getIsSorted();
				return (
					<TableCell
						key={header.id}
						onClick={header.column.getToggleSortingHandler()}
						aria-sort={
							sortDirection === "asc"
								? "ascending"
								: sortDirection === "desc"
								? "descending"
								: "none"
						}
						style={{ width: header.column.columnDef.meta?.width || "auto" }}
						className={cx(classes.nameRow, {
							[classes.selectedTableHeadRow]: sortDirection,
							[classes.tableHeadRow]: !sortDirection,
						})}
					>
						<AT.CellContainer className="flex justify-between">
							{header.column.columnDef.header}
							{header.column.getCanSort() && (
								<div className="arrow">
									<AT.DescArrow
										fill={sortDirection === "asc" ? ARROW_ACTIVE : ARROW_IDLE}
										className="arrowUp"
									/>
									<AT.DefaultArrow
										fill={sortDirection === "desc" ? ARROW_ACTIVE : ARROW_IDLE}
										className="arrowDown"
									/>
								</div>
							)}
						</AT.CellContainer>
					</TableCell>
				);
			})}
		</TableRow>
	);
};

export default ModelTaskHeader;
